<template>
  <v-form ref="form" class="infos-view">
    <div class="employee-city">
      <div class="line employee">
        <div class="field">
          {{ $t("editEventCard.employee") }}
        </div>
        <div class="data user-fullname">
          <v-autocomplete
            v-model="eventSelected.details.user.id"
            :items="users"
            item-text="fullname"
            item-value="id"
            :label="$t('editEventCard.employee')"
            :rules="emptyField"
            persistent-hint
            single-line
            color="red darken-1"
          ></v-autocomplete>
        </div>
      </div>
      <div class="line city">
        <div class="field">
          {{ $t("editEventCard.location") }}
        </div>
        <div class="data">
          <v-autocomplete
            prepend-icon="mdi-crosshairs-gps"
            v-model="eventSelected.details.location.id"
            :items="locations"
            item-text="city"
            item-value="id"
            :label="$t('editEventCard.location')"
            :rules="emptyField"
            persistent-hint
            single-line
            color="red darken-1"
          ></v-autocomplete>
        </div>
      </div>
    </div>
    <div class="dates-times">
      <div class="line dates">
        <div class="field">
          {{ $t("editEventCard.date") }}
        </div>
        <div class="data">
          <div class="data">
            <v-menu
              v-model="datePickerStart"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <p>
                  <v-text-field
                    prepend-icon="mdi-calendar"
                    v-model="eventSelected.details.dateStart"
                    :label="$t('editEventCard.dateStart')"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    color="red darken-1"
                  ></v-text-field>
                </p>
              </template>

              <v-date-picker
                v-model="eventSelected.details.dateStart"
                :max="eventSelected.details.dateEnd"
                :locale="this.$i18n.locale"
                @input="datePickerStart = false"
                color="grey"
              ></v-date-picker>
            </v-menu>
          </div>
          <div class="data">
            <v-menu
              v-model="datePickerEnd"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <p>
                  <v-text-field
                    prepend-icon="mdi-calendar"
                    v-model="eventSelected.details.dateEnd"
                    :label="$t('editEventCard.dateEnd')"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    color="red darken-1"
                  ></v-text-field>
                </p>
              </template>

              <v-date-picker
                v-model="eventSelected.details.dateEnd"
                :min="eventSelected.details.dateStart"
                :locale="this.$i18n.locale"
                @input="datePickerEnd = false"
                color="grey"
              ></v-date-picker>
            </v-menu>
          </div>
        </div>
      </div>
      <div class="line times">
        <div class="field">
          {{ $t("editEventCard.eachDay") }}
        </div>
        <div class="data">
          <div>
            <v-menu
              ref="pickerStart"
              v-model="timePickerStart"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <p>
                  <v-text-field
                    v-model="eventSelected.details.timeStart"
                    :label="$t('editEventCard.timeStart')"
                    prepend-icon="mdi-clock"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </p>
              </template>

              <v-time-picker
                v-if="timePickerStart"
                v-model="eventSelected.details.timeStart"
                :locale="this.$i18n.locale"
                @click:minute="$refs.pickerStart.save()"
              ></v-time-picker>
            </v-menu>
          </div>
          <div class="data">
            <v-menu
              ref="pickerEnd"
              v-model="timePickerEnd"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <p>
                  <v-text-field
                    v-model="eventSelected.details.timeEnd"
                    :label="$t('editEventCard.timeEnd')"
                    prepend-icon="mdi-clock"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </p>
              </template>

              <v-time-picker
                v-if="timePickerEnd"
                v-model="eventSelected.details.timeEnd"
                :locale="this.$i18n.locale"
                @click:minute="$refs.pickerEnd.save()"
              ></v-time-picker>
            </v-menu>
          </div>
        </div>
      </div>
    </div>
    <div class="comment">
      <div class="field">
        {{ $t("editEventCard.comment") }}
      </div>
      <div class="data">
        <v-textarea
          v-model="eventSelected.details.comment"
          auto-grow
          :label="$t('editEventCard.comment')"
          :rules="inputText"
          rows="1"
          row-height="30"
          color="red darken-1"
        ></v-textarea>
      </div>
    </div>
    <div class="line type">
      <div class="field">
        {{ $t("editEventCard.types") }}
      </div>
      <div class="data">
        <v-radio-group v-model="eventSelected.details.type" row>
          <v-radio
            v-for="state in $enumInterventionStatus"
            :label="state.text"
            :value="state.value"
            :key="state.value"
            color="red darken-1"
          ></v-radio>
        </v-radio-group>
      </div>
    </div>
    <div class="line valid">
      <div class="field">{{ $t("editEventCard.status") }}</div>
      <div class="data">
        <v-switch v-model="eventSelected.details.validated" color="red darken-1">
        </v-switch>
      </div>
    </div>
    <div class="line master">
      <div class="field">{{ $t("editEventCard.linkParent") }} :</div>
      <div class="data">
        <div class="data">
          <v-switch v-model="linkToMaster" color="red darken-1"></v-switch>
        </div>
      </div>
    </div>
    <div v-if="linkToMaster" class="line master">
      <v-autocomplete
        :items="masterInterventions"
        item-value="id"
        :label="$t('editEventCard.linkParent')"
        :rules="emptyField"
        persistent-hint
        single-line
        v-model="eventSelected.details.masterInterventionId"
      >
        <template slot="selection" slot-scope="data">
          {{ data.item.id }} - {{ data.item.slug }}
        </template>
        <template slot="item" slot-scope="data">
          {{ data.item.id }} - {{ data.item.slug }}
        </template>
      </v-autocomplete>
    </div>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "edit-event-info",
  props: {
    linkedIntervention: {},
    event: {
      x: null,
      id: null,
      duration: null,
      display: null,
      details: {},
      color: null,
      userType: null,
      location: null,
      course: null,
      userName: null,
      eventSiblings: [],
    },   
  },
  data() {
    return {
      emptyField: [(v) => !!v || this.$t("errorFrontEnd.requiredField")],
      inputText: [
        v => !!v || this.$t("errorFrontEnd.requiredField"),
        v => /^[ A-Za-z0-9/-]*$/.test(v) || this.$t("errorFrontEnd.specialCharacters"),
      ],
      datePickerStart: false,
      datePickerEnd: false,
      timePickerStart: false,
      timePickerEnd: false,
      isEditing: false,
      hasSaved: false,
      errors: false,
      linkToMaster: false,
      page: null,
      eventSiblingsCard: [],
    };
  },
  computed: {
    ...mapGetters("courseModule", { courses: "getCourses" }),
    ...mapGetters("locationModule", { locations: "getLocations" }),
    ...mapGetters("userModule", { users: "getUsersForm", calendarType: "getCalendar" }),
    ...mapGetters("notificationModule", { errorBackend: "getErrorBackend" }),
    ...mapGetters("eventModule", {
      masterInterventions: "getMasterEvents",
      events: "getEvents",
      eventSelected: "getEventSelected",
    }),
  },
  mounted() {
  },
  methods:{

  }
};
</script>

<style lang="scss">
.infos-edit {
  padding: 0 10px 0 0;
  display: flex;
  flex-direction: column;
  font-size: 1.2rem;
  height: 100%;
  margin: 20px 10px 0;
  overflow-y: scroll;

  .line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid var(--border-color);
  }

  .field {
    color: rgb(155, 155, 155);
  }
  
  .comment {
    text-align: justify;
    margin: 0 0 15px;
    padding: 0 0 15px;
    border-bottom: 1px solid var(--border-color);
  }

  .master {
    .data {
      text-align: right;
    }
  }
}
</style>
